var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcReportFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29102 8.125H12.791V9.375H5.29102V8.125ZM5.29102 12.5H10.291V11.25H5.29102V12.5ZM5.29102 15.625H8.41602V14.375H5.29102V15.625ZM3.41602 4.375H5.29102V6.25H12.791V4.375H14.666V8.125H15.916V4.375C15.916 3.68469 15.3563 3.125 14.666 3.125H12.791V2.5C12.791 1.80969 12.2313 1.25 11.541 1.25H6.54102C5.8507 1.25 5.29102 1.80969 5.29102 2.5V3.125H3.41602C2.7257 3.125 2.16602 3.68469 2.16602 4.375V17.5C2.16602 18.1903 2.7257 18.75 3.41602 18.75H6.54102V17.5H3.41602V4.375ZM6.54102 2.5H11.541V5H6.54102V2.5ZM17.7353 18.0847L13.8083 10.8566C13.6371 10.5478 13.194 10.5478 13.0228 10.8566L9.09589 18.0847C8.93295 18.3847 9.14977 18.75 9.49064 18.75H17.3406C17.6814 18.75 17.8983 18.3847 17.7353 18.0847ZM12.9468 13.125H13.8843V15.625H12.9468V13.125ZM13.4156 17.5C13.0705 17.5 12.791 17.2201 12.791 16.875C12.791 16.5299 13.0709 16.25 13.416 16.25C13.7611 16.25 14.041 16.5299 14.041 16.875C14.041 17.2201 13.7607 17.5 13.4156 17.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReportFile);
export default __webpack_public_path__ + "static/media/ic-report-file.de651a24857fa6abc35223a0f71a61fc.svg";
export { ForwardRef as ReactComponent };